export default {
  data: function () {
    return {
      icons: {
        openSidebar: "icon-avanti",
        closeSidebar: "icon-indietro",
        book: "icon-fascicolo icons8",
        tree: "icon-genealogia icons8",
        search: "icon-cerca-di-pi icons8",
        search_btn: "icon-cerca-di-pi",
        print: "icon-stampa icons8",
        cart: "icon-carrello-della-spesa icons8",
        cart_in: "icon-icons8-acquistare",
        cart_go: "icon-icons8-vai-alla-cassa",
        archive: "icon-banca-dati icons8",
        help: "icon-aiuto icons8", 
        info: "icon-informazioni icons8",
        info_i: "icon-informazioni-2",
        logout: "icon-spegnere icons8",
        detail: "icon-disegnotabella icons8",
        grid: "icon-griglia icons8",
        table: "icon-nuovo-foglio-di-calcolo icons8",
        image: "icon-modulo icons8",
        preview: "icon-visualizza-file icons8",
        use: "icon-collegamento-tra-computer icons8",
        documents: "icon-pannelloallegati icons8",
        user: "icon-genere-utente-neutro icons8",
        userAgent: "icon-icons8-padrone-di-casa icons8",
        lock: "icon-lucchetto",
        expand: "icon-adatta-alla-larghezza icons8",
        compress: "icon-ridurre icons8",
        val_from: "icon-ordina-a-destra",
        val_to: "icon-ordina-a-sinistra",
        range: "",
        attach: "icon-allegare",
        other: "icon-di-pi",
        circle: "icon-nuova-luna",
        empty_circle: "icon-cerchio",
        exclamation: "icon-punto-esclamativo",
        clear: "icon-cancellare",
        expandForm: "icon-freccia-espandi",
        compressForm: "icon-freccia-comprimi", //"icon-avanti",
        download: "icon-scaricare",
        dir: "icon-apri-cartella",
        leaf: "icon-impostazioni",
        child: "icon-supporto",
        cancel: "icon-eliminare",
        h_resize: "icon-ridimensiona-orizzontalmente",
        v_resize: 'icon-ridimensiona-verticale',
        adapt: "icon-proporzioni",
        left: "icon-indietro",
        right: "icon-avanti",
        down: "icon-freccia-espandi",
        tree_son: "icon-in-basso-a-destra",
        check_list: "icon-mixer-impostazioni-orizzontali icons8",
        notifier: "icon-messaggio-urgente-1 icons8",
        message: "icon-icons8-messaggio-3",

/*         part: "icon-impostazioni",
        category: "icon-cartella",
        transport: "icon-furgone",
        partstable: "icon-compasso-da-disegno",
        machine: "icon-robot",
        group: "icon-raggruppare-gli-oggetti",
        line: 'icon-icons8-star-1', //'icon-distribuzione',
        client: 'icon-icons8-circle-2',
        kit: 'icon-cassetta-degli-attrezzi',
        section: 'icon-non-selezionare-niente', */

        plus:'icon-icons8-pi-matematico',
        minus:'icon-icons8-meno-matematico-512',
        close: 'icon-icons8-eliminare',
        edit: 'icon-modificare',
        file: 'icon-icons8-file',
        user_manual: 'icon-icons8-il-manuale-duso',
        change_lang: 'icon-icons8-lingua-128'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/icons_mixin.js